module.exports = __webpack_public_path__ + "assets/img/arrow.a0fe2dd9.svg";